import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgOutlookMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 17C1 9.458 1 5.686 3.343 3.343S9.458 1 17 1c7.543 0 11.314 0 13.657 2.343S33 9.458 33 17c0 7.543 0 11.314-2.343 13.657S24.543 33 17 33c-7.542 0-11.314 0-13.657-2.343S1 24.543 1 17Z"
      fill="#fff"
      stroke="#E6E6E6"
    />
    <g clipPath="url(#OutlookMail_svg__a)">
      <path
        d="M30 17.6a.575.575 0 0 0-.277-.495h-.003l-.01-.006-9.01-5.292a1.218 1.218 0 0 0-1.35 0l-9.01 5.292-.011.006a.58.58 0 0 0 .014.998l9.01 5.292a1.218 1.218 0 0 0 1.35 0l9.01-5.292A.574.574 0 0 0 30 17.6Z"
        fill="#0A2767"
      />
      <path
        d="M11.39 14.067h5.912v5.377H11.39v-5.377ZM28.79 8.6V6.14A1.119 1.119 0 0 0 27.695 5H12.352c-.62.015-1.11.525-1.096 1.14V8.6l9.07 2.4 8.465-2.4Z"
        fill="#0364B8"
      />
      <path d="M11.256 8.6h6.046V14h-6.046V8.6Z" fill="#0078D4" />
      <path
        d="M23.349 8.6h-6.047V14l6.047 5.4h5.442V14l-5.442-5.4Z"
        fill="#28A8EA"
      />
      <path d="M17.302 14h6.047v5.4h-6.047V14Z" fill="#0078D4" />
      <path d="M17.302 19.4h6.047v5.4h-6.047v-5.4Z" fill="#0364B8" />
      <path d="M11.39 19.444h5.912v4.89H11.39v-4.89Z" fill="#14447D" />
      <path d="M23.349 19.4h5.442v5.4h-5.442v-5.4Z" fill="#0078D4" />
      <path
        d="m29.723 18.07-.011.006-9.01 5.028a1.264 1.264 0 0 1-.61.187l-.491-.285a1.232 1.232 0 0 1-.121-.07l-9.13-5.17h-.005l-.299-.166v10.178c.005.68.564 1.226 1.248 1.222h17.478c.01 0 .02-.005.03-.005.145-.009.287-.038.423-.087.06-.025.116-.054.17-.088.04-.023.11-.073.11-.073.31-.227.493-.586.495-.968V17.6a.54.54 0 0 1-.277.47Z"
        fill="url(#OutlookMail_svg__b)"
      />
      <path
        opacity={0.5}
        d="M29.516 17.56v.624l-9.42 6.436-9.753-6.85a.006.006 0 0 0-.006-.006l-.895-.534v-.45l.369-.006.78.444.018.006.066.042s9.167 5.19 9.191 5.202l.35.204c.031-.012.061-.024.098-.036.018-.012 9.1-5.082 9.1-5.082l.102.006Z"
        fill="#0A2767"
      />
      <path
        d="m29.723 18.07-.011.006-9.01 5.029c-.04.023-.079.046-.12.067a1.272 1.272 0 0 1-1.23-.067l-9.01-5.029-.01-.006a.54.54 0 0 1-.286-.47v10.178A1.234 1.234 0 0 0 11.293 29h17.46A1.234 1.234 0 0 0 30 27.78V17.6a.54.54 0 0 1-.277.47Z"
        fill="#1490DF"
      />
      <path
        opacity={0.1}
        d="m20.833 23.03-.134.075a1.259 1.259 0 0 1-.596.193l3.427 4.022 5.98 1.43c.163-.123.294-.285.379-.47l-9.056-5.25Z"
        fill="#000"
      />
      <path
        opacity={0.05}
        d="m21.444 22.69-.745.415a1.259 1.259 0 0 1-.596.193l1.605 4.393 7.803 1.057a1.21 1.21 0 0 0 .489-.97v-.131l-8.556-4.958Z"
        fill="#000"
      />
      <path
        d="M11.31 29h17.441c.269.001.53-.083.747-.24L19.6 23.007a1.225 1.225 0 0 1-.121-.07l-9.13-5.17h-.004l-.299-.167v10.144A1.26 1.26 0 0 0 11.31 29Z"
        fill="#28A8EA"
      />
      <path
        opacity={0.1}
        d="M18.512 10.9v12.798a1.103 1.103 0 0 1-.696 1.02c-.13.055-.27.084-.41.084h-7.36V10.4h1.21v-.6h6.15c.61.002 1.104.494 1.106 1.1Z"
        fill="#000"
      />
      <path
        opacity={0.2}
        d="M17.907 11.5v12.798a.972.972 0 0 1-.09.42c-.169.41-.57.68-1.017.682h-6.754v-15h6.755a1.02 1.02 0 0 1 .501.126c.371.185.605.562.605.974Z"
        fill="#000"
      />
      <path
        opacity={0.2}
        d="M17.907 11.5v11.598A1.112 1.112 0 0 1 16.8 24.2h-6.754V10.4h6.755a1.02 1.02 0 0 1 .501.126c.371.185.605.562.605.974Z"
        fill="#000"
      />
      <path
        opacity={0.2}
        d="M17.302 11.5v11.598c0 .607-.495 1.099-1.106 1.102h-6.15V10.4h6.15c.611 0 1.107.492 1.106 1.1Z"
        fill="#000"
      />
      <path
        d="M5.108 10.4h11.086c.612 0 1.108.492 1.108 1.1v11c0 .608-.496 1.1-1.108 1.1H5.108A1.104 1.104 0 0 1 4 22.5v-11c0-.608.496-1.1 1.108-1.1Z"
        fill="url(#OutlookMail_svg__c)"
      />
      <path
        d="M7.464 15.013a3.208 3.208 0 0 1 1.266-1.388 3.851 3.851 0 0 1 2.012-.5 3.584 3.584 0 0 1 1.862.474c.53.315.959.775 1.231 1.326.297.607.445 1.276.432 1.95a4.487 4.487 0 0 1-.444 2.04c-.28.57-.72 1.048-1.27 1.372a3.727 3.727 0 0 1-1.931.488 3.662 3.662 0 0 1-1.903-.48 3.23 3.23 0 0 1-1.248-1.329 4.151 4.151 0 0 1-.437-1.926 4.61 4.61 0 0 1 .43-2.027Zm1.35 3.258c.145.365.392.682.712.913a1.87 1.87 0 0 0 1.113.332 1.96 1.96 0 0 0 1.187-.343 1.99 1.99 0 0 0 .692-.913 3.52 3.52 0 0 0 .22-1.274 3.849 3.849 0 0 0-.208-1.29 2.04 2.04 0 0 0-.67-.951 1.85 1.85 0 0 0-1.177-.36 1.93 1.93 0 0 0-1.138.335 2.097 2.097 0 0 0-.726.921 3.634 3.634 0 0 0-.005 2.631v-.001Z"
        fill="#fff"
      />
      <path d="M23.349 8.6h5.442V14h-5.442V8.6Z" fill="#50D9FF" />
    </g>
    <defs>
      <linearGradient
        id="OutlookMail_svg__b"
        x1={20.023}
        y1={17.6}
        x2={20.023}
        y2={29}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35B8F1" />
        <stop offset={1} stopColor="#28A8EA" />
      </linearGradient>
      <linearGradient
        id="OutlookMail_svg__c"
        x1={6.311}
        y1={9.541}
        x2={14.891}
        y2={24.517}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1784D9" />
        <stop offset={0.5} stopColor="#107AD5" />
        <stop offset={1} stopColor="#0A63C9" />
      </linearGradient>
      <clipPath id="OutlookMail_svg__a">
        <path fill="#fff" transform="translate(4 5)" d="M0 0h26v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgOutlookMail);
export default Memo;
